import smoothscroll from 'smoothscroll-polyfill';
import 'core-js/features/object/from-entries';

smoothscroll.polyfill();

// eslint-disable-next-line import/no-anonymous-default-export
export default {};
